package com.klantenstop.web.pages

import com.materialkobweb.components.toast.ToastManager
import com.klantenstop.web.data.repos.CategoryRepo
import com.klantenstop.web.utils.MVI
import com.materialkobweb.utils.ViewModel
import com.klantenstop.web.utils.catchWithCancellation
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class HomeViewModel(
    private val categoryRepo: CategoryRepo = CategoryRepo
) : ViewModel(), MVI<HomeContract.State, HomeContract.Intent, HomeContract.Effect> {

    private val _state = MutableStateFlow(HomeContract.State())
    override val state: StateFlow<HomeContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<HomeContract.Effect>()
    override val effect: SharedFlow<HomeContract.Effect> = _effect.asSharedFlow()

    init {
        sendIntent(HomeContract.Intent.LoadCategories)
    }

    override fun sendIntent(intent: HomeContract.Intent) = coroutineScope.launch {
        when (intent) {
            is HomeContract.Intent.LoadCategories -> loadCategories()
        }
    }

    private suspend fun loadCategories() {
        val categories = catchWithCancellation(
            block = { categoryRepo.getCategories() },
            onError = { e ->
                ToastManager.error(
                    e.message ?: "Er is een fout opgetreden bij het laden van categorieën. Probeer het later opnieuw.",
                    title = "Laden mislukt"
                )
            }
        ) ?: emptyList()

        updateState { it.copy(categories = categories, loading = false) }
    }

    override fun emitEffect(effect: HomeContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (HomeContract.State) -> HomeContract.State) {
        _state.update(block)
    }
}
